/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Prep_Ahead_RemoveInputs */

const en_editor_prep_ahead_remove = /** @type {(inputs: Editor_Prep_Ahead_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove task`)
};

const de_editor_prep_ahead_remove = /** @type {(inputs: Editor_Prep_Ahead_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufgabe entfernen`)
};

/**
* | output |
* | --- |
* | "Remove task" |
*
* @param {Editor_Prep_Ahead_RemoveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_prep_ahead_remove = /** @type {((inputs?: Editor_Prep_Ahead_RemoveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Prep_Ahead_RemoveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_prep_ahead_remove(inputs)
	return en_editor_prep_ahead_remove(inputs)
});